import image1 from '../../../../assets/images/work/opg-sim/OPG_detailed_img_1.jpg';
import image2 from '../../../../assets/images/work/opg-sim/OPG_detailed_img_2.jpg';
import image4 from '../../../../assets/images/work/opg-sim/OPG_detailed_abovefooter.jpg';

import artwork from '../../../../assets/images/art_2.png';

const Data_OPGIncidentCommand = {
    content: (
        <>
            {/* components to be */}

            {/* content */}
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">PROBLEM</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            Ontario Power Generation required an incident command training platform that
                                            could support realistic, role-based emergency response exercises. Existing
                                            tools and visual systems were not engaging enough and didn't provide the
                                            flexibility needed to control the scenario as it unfolded. Without the
                                            ability to actively drive visuals, conditions, and team outcomes in real
                                            time, exercises became limited and predictable, reducing the impact of the
                                            role-playing experience.
                                        </p><br/>
                                        <p>
                                            The gap was clear. Incident command is learned by doing. Commanders need to
                                            read an evolving scene, assign resources, coordinate teams, and communicate
                                            with multiple stakeholders under pressure. OPG needed a simulation that
                                            could place participants inside the command role while giving a director
                                            full control over the incident environment and scenario pacing.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-6 second-column">
                                    <h4 className="heading heading-small light-2">CHALLENGES</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            The solution needed to feel credible for emergency fire services while
                                            remaining flexible enough for instructors to run many different exercises.
                                            That meant building a director-driven system where scenarios could be
                                            adjusted in real time without breaking immersion. The platform also needed
                                            to support multiple participants and viewpoints so that command, operations,
                                            and communications could train together in a shared event.
                                        </p><br/>
                                        <p>
                                            Beyond visuals, the challenge was interaction. Teams needed to deploy and
                                            reposition apparatus, assign equipment, and influence outcomes through
                                            decision-making. Fires, smoke, and weather conditions had to behave
                                            realistically, while still giving the director control over intensity,
                                            timing, and escalation to match training objectives.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="project-content">
                <div className="project-content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-large dark-1">
                                        A director-controlled incident command simulation that turns role-play into a
                                        dynamic, visual, multi-team training experience.
                                    </h2>
                                    <div className="paragraph dark-1">
                                        <p>
                                            We built a simulation tool for OPG that gives emergency fire services a
                                            platform to train incident command in a way that feels real, adaptable, and
                                            team-based. At the center of the experience is a director who controls the
                                            scenario progression, environment conditions, and key events, allowing each
                                            training session to be paced and shaped around the learning objectives and
                                            the team's decisions.
                                        </p><br/>
                                        <p>
                                            Participants step into their roles and respond to an evolving incident.
                                            The commander operates from inside a command vehicle, viewing the incident
                                            scene and making decisions as conditions change. Team members can train
                                            using their own perspectives, while support roles such as crisis
                                            communications can engage with the same incident through a dedicated view
                                            that presents the scenario as a news report, adding realism to messaging
                                            and public-response coordination.
                                        </p>
                                    </div>

                                    <div className="heading heading-medium dark-1">
                                        <p>Strategy Session</p>
                                    </div>
                                    <div className="paragraph dark-1">
                                        <p>
                                            The focus was to make incident command training feel like an active event
                                            rather than a scripted demo. The director can deploy fire teams, assign
                                            vehicles and equipment, and shift conditions in real time to create
                                            decision points. Commanders can communicate priorities, request resources,
                                            and coordinate response, while the simulation provides the visual and
                                            environmental context that makes those decisions meaningful.
                                        </p><br/>
                                        <p>
                                            Realism was treated as a training tool. Weather impacts visibility and
                                            fire behavior. Smoke evolves and affects the scene. Teams can be assigned
                                            to equipment such as ground monitors or hoses, adjusting position, spray
                                            intensity, and direction. These details add a layer of immersion that
                                            supports better role-play, more natural communication, and stronger
                                            command habits.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image-wrapper">
                        <div className="single-image">
                            <img src={image1} alt="OPG Incident Command project screenshot 8" />
                        </div>
                        <div className="single-image">
                            <img src={image2} alt="OPG Incident Command project screenshot 9" />
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-medium dark-1">Plan of Action</h2>
                                    <div className="paragraph dark-1">
                                        <p>
                                            We designed the platform around a director-led workflow that mirrors how
                                            real training exercises are facilitated. The director can introduce events,
                                            escalate conditions, and control pacing without interrupting the scenario.
                                            The system supports role-based viewpoints so that command, operations, and
                                            communications teams can train together while seeing the incident from the
                                            perspective that matches their responsibilities.
                                        </p><br/>
                                        <p>
                                            The simulation also supports tactical interaction. The director can deploy
                                            teams and equipment, reposition vehicles, and adjust suppression tools to
                                            match the response plan. These controls allow the training session to
                                            evolve naturally based on decisions, reinforcing coordination, radio
                                            communication, and command structure under realistic pressure.
                                        </p><br/>
                                        <p>
                                            Environmental realism was built in as a controllable layer. Fire intensity,
                                            smoke density, weather conditions, and visibility can be tuned to create
                                            scenarios ranging from introductory training to high-pressure command
                                            exercises. This gives instructors a reliable platform to run repeatable
                                            training while still keeping each session fresh, engaging, and responsive
                                            to the team's actions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image">
                        <img src={image4} alt="OPG Incident Command project screenshot 10" />
                    </div>
                </div>
            </div>

            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">RESULTS</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            OPG now has a flexible simulation platform that supports realistic incident
                                            command training without the limitations of static visuals or rigid
                                            scenario flow. By combining director control with immersive, role-based
                                            participation, the experience strengthens situational awareness, command
                                            communication, and coordinated team response in a way that is repeatable
                                            and safe.
                                        </p><br/>
                                        <p>
                                            The result is a training environment where decisions drive outcomes,
                                            teams can practice coordination under pressure, and instructors can adjust
                                            pacing and conditions in real time. This creates a more engaging and
                                            credible role-play experience that better prepares participants for
                                            real-world emergency response.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>LBI / PC</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>Ontario Power Generation</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">LOCATION</h4>
                    <div className="paragraph light-1">
                      <p>Ontario, Canada</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">WEBSITE</h4>
                    <div className="paragraph light-1">
                      <p>
                        <a href="https://www.opg.com/" target="_blank" rel="noreferrer">
                          www.opg.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-content-footer">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        Have an idea?
                                        <br />
                                        Let's explore it together.
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper">
                                        <a className="button button-1" href="/Contact">
                                            Contact Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="artwork artwork-2" aria-hidden="true">
                        <img src={artwork} alt="" />
                    </div>
                </div>
            </div>
        </>
    ),
};

export default Data_OPGIncidentCommand;


